import { ThemeColors } from '~/themes/colors'

interface CallControlColors {
  ControlButton: {
    Background: ThemeColors
    Hover: {
      Icon: ThemeColors
      Background: ThemeColors
    }
    Selected: {
      Icon: ThemeColors
      Background: ThemeColors
    }
    Disabled: {
      Icon: ThemeColors
    }
  }
  ControlBar: {
    Background: ThemeColors
    Border: ThemeColors
  }
  ControlDrawer: {
    Background: ThemeColors
    Border: ThemeColors
  }
  TransferInput: {
    Background: ThemeColors
    Border: ThemeColors
    Placeholder: {
      FontColor: ThemeColors
    }
  }
}

export const callControlColors: CallControlColors = {
  ControlButton: {
    Background: {
      default: 'gray.300',
    },
    Hover: {
      Icon: {
        default: 'blue.900',
      },
      Background: {
        default: 'blue.300',
      },
    },
    Selected: {
      Icon: {
        default: 'blue.900',
      },
      Background: {
        default: 'blue.300',
      },
    },
    Disabled: {
      Icon: {
        default: 'gray.600',
      },
    },
  },
  ControlBar: {
    Background: {
      default: 'white',
    },
    Border: {
      default: 'gray.300',
    },
  },
  ControlDrawer: {
    Background: {
      default: 'gray.100',
    },
    Border: {
      default: 'gray.300',
    },
  },
  TransferInput: {
    Background: {
      default: 'gray.200',
    },
    Border: {
      default: 'gray.500',
    },
    Placeholder: {
      FontColor: {
        default: 'gray.600',
      },
    },
  },
}
